import AllRoutes from "./routes";
// import './App.css';

export default function App() {
   return (
    <AllRoutes />
  );
}


